import { Property } from '../../types';
import api from '../../utils/api';

export const createProperty = (variables: Property) =>
  api.post({
    url: `/property`,
    variables,
  });
